exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.warning[data-v-54364d91] {\n  background-color: #e05050;\n  color: white;\n}\n.ok[data-v-54364d91] {\n  background-color: #58cc1a;\n  color: white;\n}\n.content[data-v-54364d91] {\n  display: inline-block;\n  vertical-align: top;\n}\n.content-icon[data-v-54364d91] {\n  width: 5%;\n  margin: 5px 0 0 0;\n  text-align: center;\n}\n.content-text[data-v-54364d91] {\n  width: 94%;\n  max-width: calc(100% - 30px);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-54364d91","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ReschedulingPage/NotificationBox.vue
// module id = 514
// module chunks = 0